import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  PayrollRunSelectionAction,
  PayrollRunSelectionComponent,
} from '../../../export/shared/payroll-run-selection/payroll-run-selection.component';

@Component({
  selector: 'app-createbireport-list',
  imports: [PayrollRunSelectionComponent],
  templateUrl: './createbireport-list.component.html',
  styleUrl: './createbireport-list.component.scss',
})
export class CreatebireportListComponent {
  private router = inject(Router);

  private readonly navigationState =
    this.router.getCurrentNavigation()?.extras?.state ?? history.state;
  readonly initialOpdrachtgeverId = (this.navigationState?.['opdrachtgeverId'] as string) ?? null;
  readonly initialInstellingId = (this.navigationState?.['instellingId'] as string) ?? null;

  onExport(action: PayrollRunSelectionAction): void {
    this.router.navigate(['/proces/exportprocessing/createbireport/editable', action.importRunId], {
      state: {
        opdrachtgeverName: action.opdrachtgeverName,
        opdrachtgeverId: action.opdrachtgeverId,
        instellingId: action.instellingId,
      },
    });
  }
}
